import Link from 'next/link';
import { genericEventHandler } from '@/analytics/events';
import { EventNames, GlobalEvents } from '@/analytics/events/constants';
import StringAccessor from '@/components/cmsConfig/stringAccessor';
import { StyledPrimaryButton } from '@/components/uielements/primaryButton/styles';
import { ROUTES } from '@/constants/routes';

interface Props {
  label: string;
}

export const OrderNowCTA = ({ label }: Props) => (
  <Link href={{ pathname: ROUTES.STORES }} passHref legacyBehavior>
    <StyledPrimaryButton
      data-css-override="StyledPrimaryButton"
      aria-label="Go to the store locator page"
      onClick={() => {
        genericEventHandler(GlobalEvents.GENERIC__CTA, {
          name: EventNames.ORDER_NOW,
          details: label,
        });
      }}
    >
      <StringAccessor accessor="rewards.order_now_button" />
    </StyledPrimaryButton>
  </Link>
);
